import React, { useState } from 'react';
import { Loader2, Route } from 'lucide-react';
import { toast } from 'sonner';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { joApi, joErr } from '@/services/processingJoApi';
import { ROUTES, routeLabel } from './JoBits';

export const RouteOptions = ({ value, onChange, testPrefix = 'jo-route' }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid={testPrefix}>
    {ROUTES.map(([v, l, hint]) => (
      <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${testPrefix}-${v.toLowerCase()}`}
        className={`rounded-md border px-3 py-2 text-left text-sm transition-colors ${value === v ? 'border-[#2D5F4F] bg-[#2D5F4F]/5 text-[#2D5F4F]' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}>
        <div className="font-medium">{l}</div><div className="text-[11px] text-gray-500">{hint}</div>
      </button>
    ))}
  </div>
);

/** Route badge on the job order + change it while no piece has passed Processing Inward. */
export const JoRoute = ({ o, onDone }) => {
  const [open, setOpen] = useState(false);
  const [route, setRoute] = useState(o.route);
  const [busy, setBusy] = useState(false);
  const canChange = o.status === 'OPEN' && !o.route_locked;
  const save = async () => {
    setBusy(true);
    try { await joApi.setRoute(o.jo_id, route); toast.success(`${o.jo_id} is now on the ${routeLabel(route)}`); setOpen(false); onDone(); }
    catch (e) { toast.error(joErr(e, 'Could not change the route')); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Badge className="bg-[#1A1F2E] text-white border-0 font-medium" data-testid="jo-route-badge"><Route className="w-3.5 h-3.5 mr-1" />{routeLabel(o.route)}</Badge>
      {canChange && <Button variant="outline" size="sm" onClick={() => { setRoute(o.route); setOpen(true); }} data-testid="jo-route-change-btn">Change route</Button>}
      {!canChange && o.status === 'OPEN' && <span className="text-xs text-gray-500" data-testid="jo-route-locked">Route is fixed — pieces have passed Processing Inward</span>}
      <Dialog open={open} onOpenChange={(v) => !busy && setOpen(v)}>
        <DialogContent className="max-w-md" data-testid="jo-route-dialog">
          <DialogHeader><DialogTitle>Route for {o.jo_id}</DialogTitle>
            <DialogDescription>Where the pieces go after they come back from the jobber.</DialogDescription></DialogHeader>
          <RouteOptions value={route} onChange={setRoute} testPrefix="jo-route-opt" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Back</Button>
            <Button onClick={save} disabled={busy || route === o.route} className="bg-[#2D5F4F] hover:bg-[#234A3D]" data-testid="jo-route-save-btn">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Save route</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
